import { render } from "./PendingDowngrade.vue?vue&type=template&id=97789eba"
import script from "./PendingDowngrade.vue?vue&type=script&lang=js"
export * from "./PendingDowngrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__